import React from 'react';
import { Card, Badge } from 'react-bootstrap';
import { 
  FaCalendarCheck, 
  FaClock,
  FaCheckCircle,
  FaTimesCircle,
  FaHourglassHalf
} from 'react-icons/fa';

const EmployeeLeaveCard = ({ pendingLeaves, loading }) => {
  const getStatusBadge = (status) => {
    switch (status?.toLowerCase()) {
      case 'pending':
        return <Badge bg="warning" text="dark">Pending</Badge>;
      case 'approved':
        return <Badge bg="success">Approved</Badge>;
      case 'rejected':
        return <Badge bg="danger">Rejected</Badge>;
      default:
        return <Badge bg="secondary">{status}</Badge>;
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    try {
      const date = new Date(dateStr);
      return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
    } catch {
      return String(dateStr);
    }
  };

  return (
    <Card className="border-0 shadow-sm employee-leave-card rounded-4">
      <Card.Header className="bg-white border-0 py-3 d-flex align-items-center">
        <h5 className="mb-0 fw-bold d-flex align-items-center">
          <FaCalendarCheck className="me-2 text-primary" />
          Pending Leave Requests
        </h5>
      </Card.Header>
      <Card.Body className="pt-0">
        {loading ? (
          <div className="text-center py-4 text-muted">
            <small>Loading requests...</small>
          </div>
        ) : pendingLeaves && pendingLeaves.length > 0 ? (
          <div className="pending-list">
            {pendingLeaves.slice(0, 5).map((leave) => (
              <div key={leave.id} className="pending-item d-flex justify-content-between align-items-center py-3 border-bottom">
                <div className="pending-info d-flex flex-column">
                  <span className="pending-type fw-semibold text-dark">
                    {(leave.leaveType || 'Leave Request').replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                  </span>
                  <span className="pending-dates text-muted small mt-1">
                    {formatDate(leave.fromDate || leave.startDate)} - {formatDate(leave.toDate || leave.endDate)} ({leave.daysCount || leave.days || '—'} days)
                  </span>
                </div>
                <div className="pending-status">
                  {getStatusBadge(leave.status)}
                </div>
              </div>
            ))}
            {pendingLeaves.length > 5 && (
              <small className="text-muted d-block mt-3 text-center">
                +{pendingLeaves.length - 5} more pending requests
              </small>
            )}
          </div>
        ) : (
          <div className="text-center text-muted py-4">
            <FaHourglassHalf className="text-muted mb-2" style={{ fontSize: '1.5rem', opacity: 0.5 }} />
            <p className="mb-0 small">No pending leave requests</p>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default EmployeeLeaveCard;
